import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, homeRouteFor } from '../contexts/AuthContext';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Les identifiants sont vérifiés par n8n contre la base Notion
    const result = await login(username, password);

    if (result.success) {
      // Un contributeur ne révise pas : on l'envoie sur la bibliothèque
      navigate(homeRouteFor(result.user.role), { replace: true });
    } else {
      setError(result.error);
      setPassword(''); // Vider le mot de passe
    }

    setIsLoading(false);
  };

  const field =
    'w-full px-4 py-3 bg-surface border border-sand-300 rounded-xl text-ink-900 ' +
    'placeholder:text-ink-400 outline-none transition-colors ' +
    'focus:border-clay-500 focus:ring-2 focus:ring-clay-500/20';

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-sm">
        {/* Titre — la page d'accueil de l'application, pas un formulaire d'admin */}
        <div className="mb-10">
          <h1 className="font-display text-[2.75rem] leading-none text-ink-900">
            Tigrigna
          </h1>
          <p className="label-caps mt-3">Révision espacée</p>
          <p className="mt-6 text-ink-500 leading-relaxed">
            Vos cartes vous attendent. Connectez-vous pour reprendre
            là où vous vous étiez arrêté.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="username" className="label-caps block mb-2">
              Nom d'utilisateur
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className={field}
              autoComplete="username"
              autoFocus
            />
          </div>

          <div>
            <label htmlFor="password" className="label-caps block mb-2">
              Mot de passe
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={field}
              autoComplete="current-password"
            />
          </div>

          {error && (
            <p className="text-sm text-rating-forgot border-l-2 border-rating-forgot pl-3 py-1">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-4 bg-clay-500 text-onAccent rounded-xl font-medium
                       hover:bg-clay-600 disabled:bg-sand-300 transition-colors shadow-card"
          >
            {isLoading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>

        <p className="label-caps mt-8 text-center">
          Connexion sécurisée via HTTPS
        </p>
      </div>
    </div>
  );
}
